import { WorklistData, WorkListDrawerTab } from 'models/worklist';
import { Box, Tabs } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DRAWER_PADDING } from 'utils/general';
import { BsChatText, BsClipboard2Pulse } from 'react-icons/bs';
import { DrawerNote } from './DrawerNote';
import { WorklistDrawerHeader } from './WorklistDrawerHeader';
import { WorklistDrawerDetails } from './WorklistDrawerDetails';
import { WorklistIndicator } from './WorklistIndicator';

interface Props {
  item: WorklistData;
  tab: WorkListDrawerTab;
}

export const WorklistDrawer = ({ item, tab }: Props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(tab);

  return (
    <Box pt={'sm'} px={DRAWER_PADDING}>
      <WorklistDrawerHeader title={t('alert_title')} documentId={item.id} />
      <Tabs value={activeTab} variant={'outline'} onChange={(value) => value && setActiveTab(value)}>
        <Tabs.List>
          <Tabs.Tab leftSection={<BsClipboard2Pulse />} value={WorkListDrawerTab.Details}>
            {t('details_title')}
          </Tabs.Tab>
          <WorklistIndicator documentId={item?.id}>
            <Tabs.Tab leftSection={<BsChatText />} value={WorkListDrawerTab.Notes}>
              {t('notes_label')}
            </Tabs.Tab>
          </WorklistIndicator>
        </Tabs.List>

        <Tabs.Panel value={WorkListDrawerTab.Details}>
          <WorklistDrawerDetails documentId={item.id} />
        </Tabs.Panel>
        <Tabs.Panel value={WorkListDrawerTab.Notes}>
          <DrawerNote documentId={item.id} />
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};
